import type { ClinicLocationOption } from '@/services/main/treatmentReport';

export const formatClinicLocationLabel = (location: ClinicLocationOption): string =>
  [location.address1, location.address2, location.address3].filter(Boolean).join('') ||
  location.location_name;

export const formatMassagerOptionLabel = (massager: {
  name: string | null;
  serial_number?: number | null;
}): string =>
  massager.serial_number != null
    ? `${massager.serial_number}：${massager.name ?? ''}`
    : (massager.name ?? '');

export const normalizeNonPrintColumn = (key: string): string =>
  key === 'address3' ? 'location_name' : key;

export const toBackendNonPrintColumn = (key: string): string =>
  key === 'location_name' ? 'address3' : key;

export const buildAddressFromSearchResult = (result: any): string =>
  result.full_address ||
  result.address ||
  `${result.prefecture_name || ''}${result.city_name || ''}${result.town_name || result.name || ''}`;

